export const GET_ALL_PAYMENT_REQUEST = "GET_ALL_PAYMENT_REQUEST";
export const GET_ALL_PAYMENT_SUCCESS = "GET_ALL_PAYMENT_SUCCESS";
export const GET_ALL_PAYMENT_FAILURE = "GET_ALL_PAYMENT_FAILURE";

export const VENDOR_TRANSFER_PAYMENT_REQUEST =
  "VENDOR_TRANSFER_PAYMENT_REQUEST";
export const VENDOR_TRANSFER_PAYMENT_SUCCESS =
  "VENDOR_TRANSFER_PAYMENT_SUCCESS";
export const VENDOR_TRANSFER_PAYMENT_FAILURE =
  "VENDOR_TRANSFER_PAYMENT_FAILURE";
